var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"alert",attrs:{"text":"","type":"warning"}},[_c('p',[_vm._v("会社一覧にない場合は先にテナントを削除してください。")]),_c('v-divider',{staticClass:"my-2 warning",staticStyle:{"opacity":"0.22"}}),_c('p',[_vm._v("削除反映予定の会社は表示されません。")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }